export {};

import { trackEvent } from '../utils/analytics';

// FAQ: track which question is opened
document.querySelectorAll<HTMLDetailsElement>('.section-faq details').forEach((details, index) => {
  details.addEventListener('toggle', () => {
    if (!details.open) return;
    const question = details.querySelector('summary')?.textContent?.trim() ?? '';
    trackEvent('faq_open', { question, question_index: index });
  });
});

// Slidecard: track horizontal scroll to a new card
const wrapper = document.querySelector<HTMLElement>('.bottom-slider-wrapper');
if (wrapper) {
  let scrollTimer: ReturnType<typeof setTimeout>;
  wrapper.addEventListener('scroll', () => {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      const cardWidth = wrapper.querySelector<HTMLElement>('.bottom-slider-wrapper-card')?.offsetWidth ?? 0;
      if (cardWidth === 0) return;
      const toIndex = Math.round(wrapper.scrollLeft / cardWidth);
      trackEvent('slidecard_swipe', { to_index: toIndex });
    }, 150);
  }, { passive: true });
}
